export default __webpack_public_path__ + "04721db0b27899c147b9cdafb1e986e9.svg";